import { createFileRoute } from "@tanstack/react-router"
import { FriendsLanguagePage } from "@/pages/profile/friends-language"

export const Route = createFileRoute(
	"/_authenticated/profile/friends-language",
)({
	component: FriendsLanguagePage,
})
